import React from 'react';
import { LayoutPage } from 'components/layouts';
import { Divider } from 'antd';
import './style.css';

const TermsEmployer = () => {
  return (
    <LayoutPage>
      <LayoutPage.Content className="container">
        <div className="content">
          <h1>Terms and Conditions - Employers</h1>
          <p>
            <strong>
              PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE
              REGISTERING FOR AN ACCOUNT WITH MY SHIFTS LIMITED
            </strong>
          </p>
          <p>
            This page (together with our Privacy Policy and Terms of Website
            Use) tells you information about us and the legal terms and
            conditions on which we offer the opportunity for you to connect with
            health and social care workers through our website.
          </p>
          <p>
            These terms and conditions (<strong>Terms</strong>) will apply to
            the operation of your MyShifts Account and any contract between us
            for the sale of Tokens and/or Token Bundles to you which you may use
            to purchase Connections (<strong>Contract</strong>). Please read
            these Terms carefully and make sure that you understand them.
          </p>
          <p>
            We amend these Terms from time to time. Every time you wish to
            purchase Tokens and/or a Token Bundle, please check these Terms to
            ensure you understand the Terms that apply at that time. These Terms
            were most recently updated on 1<sup>st</sup> April 2021.
          </p>

          <Divider />

          <h3>1. Definitions</h3>
          <p>
            <strong>Connection</strong>: the provision to you of the contact
            details of a Worker who may be available for a Shift (and
            <strong>Connections</strong> shall be construed accordingly).
          </p>
          <p>
            <strong>CQC Number: </strong>your Care Quality Commission
            registration number.<strong> </strong>
          </p>
          <p>
            <strong>Employer: </strong>means you, the person, business or
            company who seeks Workers via our website.<strong> </strong>
          </p>
          <p>
            <strong>Fee</strong>: has the meaning given to it in clause 4.2
          </p>
          <p>
            <strong>Invalid Connection</strong>: has the meaning given to it in
            clause 7.1.
          </p>
          <p>
            <strong>MyShifts Account</strong>: the online account you register
            with us, with which you use to sign into our website.
          </p>
          <p>
            <strong>Shift: </strong>the health and/or social care work shift
            that you would like carrying out by a Worker (and
            <strong>Shifts </strong>shall be construed accordingly).
          </p>
          <p>
            <strong>Tokens</strong>: the means by which you pay for Connections.
          </p>
          <p>
            <strong>Token Bundle</strong>: any bundle of Tokens (from time to
            time) which you purchase.
          </p>
          <p>
            <strong>Workers</strong>: health and social care workers who have
            signed up for a MyShifts Account.
          </p>

          <Divider />

          <h3>2. Information about us</h3>
          <ol>
            <li>
              We operate the website My-Shifts.co.uk (“
              <strong>our website</strong>”). We are My Shifts Limited a company
              registered in England and Wales under company number 10967405 and
              with our registered office at Optima House, 100 Manchester Road,
              Denton, Manchester, United Kingdom, M34 3PR.
            </li>
            <li>
              You can contact us by telephoning our customer service team at by
              writing to us at the email address -
              <a href="mailto:hello@my-shifts.co.uk">hello@my-shifts.co.uk</a>
            </li>
            <li>
              If we have to contact you, we will do so by telephone or by
              writing to you at the email address or postal address you provided
              to us when opening your MyShifts Account.
            </li>
            <li>
              "Writing" includes emails. When we use the words "writing" or
              "written" in these terms, this includes emails.
            </li>
          </ol>

          <Divider />

          <h3>3. Your MyShifts Account and password</h3>
          <ol>
            <li>
              In order to open a MyShifts Account and purchase Tokens and/or
              Token Bundles you will be required to provide us with the
              following:
              <ol>
                <li>
                  full contact details, including the full name of the Employer,
                  your CQC/Ofsted Registration number, telephone number, email
                  address and postal address;
                </li>
                <li>
                  details of the health and/or social care services you supply;
                </li>
                <li>
                  if the services you supply require the Workers to have certain
                  qualifications, membership or certifications, you must notify
                  us of such; and
                </li>
                <li>details of the Shifts you require Workers for.</li>
              </ol>
            </li>
            <li>
              You are responsible for ensuring that all persons who access our
              website through your internet connection are aware of these terms
              of use and other applicable terms and conditions, and that they
              comply with them.
            </li>
            <li>
              If you choose, or you are provided with, a user identification
              code, password or any other piece of information as part of our
              security procedures, you must treat such information as
              confidential. You must not disclose it to any third party.
            </li>
            <li>
              If you know or suspect that anyone other than you, knows your user
              identification code or password, you must promptly notify us by
              emailing us at hello@my-shifts.co.uk
            </li>
            <li>
              You can close your MyShifts Account at any time by emailing us at
              <a href="mailto:hello@my-shifts.co.uk">hello@my-shifts.co.uk</a>
              and put ‘Close Account’ in the Subject Field.
            </li>
            <li>
              We may at our discretion close your MyShifts Account if it has
              been inactive for 12 months or more.
            </li>
            <li>
              We may disable or close (at our discretion) your MyShifts Account
              at any time with immediate effect if, in our reasonable opinion,
              you have failed to comply with any of the provisions of these
              Terms, or if we receive any complaint about you.
            </li>
            <li>
              If at any time you or we close your MyShifts Account (for whatever
              reason):
              <ol>
                <li>
                  the balance of any amount credited to your MyShifts Account
                  shall expire upon such closure and will not be refundable to
                  your debit or credit card (or otherwise refunded to you);
                </li>
                <li>
                  insofar that the balance of any amount credited to your
                  account is insufficient to pay all or any part of any
                  outstanding invoices, you shall immediately pay to us all
                  outstanding unpaid invoices and interest and, in respect of
                  Connections supplied but for which no invoice has been
                  submitted, we shall submit an invoice, which shall be payable
                  by you immediately on receipt; and
                </li>
                <li>
                  your Tokens will automatically expire upon such termination
                  and you will not be able to use them to purchase Connections
                  nor will they be refundable.
                </li>
              </ol>
            </li>
          </ol>

          <Divider />

          <h3>4. Connecting with Workers</h3>
          <ol style={{ counterReset: 'lis 8' }}>
            <li>
              Subject to clause 4.2, you may use our website to post details of
              Shifts.
            </li>
            <li>
              We will send anonymised details, of Workers to you, who we believe
              (based on the information you and the Worker provide to us) are
              going to be available and suited to the relevant Shift/s. You will
              receive a brief description of the Worker’s skills, qualifications
              and their expected minimum hourly pay rate and the total number of
              Tokens payable by you, to us, to purchase the Connection (
              <strong>Fee</strong>).
            </li>
            <li>
              If you wish to purchase a Connection, then you should follow the
              online prompts.
            </li>
            <li>
              If you purchase a Connection, we will send you the contact details
              of the Worker for that Shift. It is your responsibility to contact
              the Worker to negotiate any potential contract with them.
            </li>
            <li>
              We accept no liability for the information provided by Worker. It
              is your responsibility to verify all details (including any
              applicable qualifications) directly with the Worker if you
              successfully purchase a Connection.
            </li>
            <li>
              You agree and accept that when you purchase a Connection from us,
              you are purchasing an opportunity to be introduced to a Worker and
              that we do not offer any guarantee that the Connection will result
              in any work being provided to you.
            </li>
            <li>
              We may at our entire discretion, refuse to supply a worker’s
              identity or details given and/or cancel your MyShifts Account with
              immediate effect if we reasonably believe that you are purchasing
              the Connections as a recruiter, agent, reseller and/or
              intermediary.
            </li>
            <li>
              You shall maintain in force, with a reputable insurance company,
              professional indemnity insurance and public liability insurance to
              cover the liabilities that may arise under or in connection with
              these Terms and any subsequent engagement of a Worker and shall
              produce to
              <br />
              <br />
              us on request both the insurance certificate giving details of
              cover and the receipt for the current year’s premium in respect of
              each insurance.
            </li>
          </ol>

          <Divider />

          <h3>5. Tokens and Token Bundles</h3>
          <ol style={{ counterReset: 'lis 16' }}>
            <li>
              You can purchase Tokens and/or Token Bundles from time to time by
              following the relevant prompts on your MyShifts Account. You will
              only be charged for the Tokens and/or Token Bundles you purchase.
            </li>
            <li>
              Tokens expire after a period of 12 months beginning on the day on
              which they were issued to you.
            </li>
            <li>
              If you purchase one of our Token Bundles, it is solely your
              responsibility to choose the Token Bundle which is most suited to
              your requirements.
            </li>
            <li>
              Our acceptance of your purchase of Tokens and/or a Token Bundle
              will take place when we make the applicable Tokens available to
              your MyShifts Account.
            </li>
            <li>
              If at any time you fail to make a payment due to us, you will not
              be permitted to use any Tokens to purchase a Connection until you
              have paid all outstanding payments due from you to us. Where you
              fail to make payment when due, we may at our entire discretion,
              close your MyShifts Account and clause 3.8 shall apply.
            </li>
          </ol>

          <Divider />

          <h3>6. Payment Terms</h3>
          <ol style={{ counterReset: 'lis 21' }}>
            <li>
              Payment for Tokens and/or Token Bundles is due in full and cleared
              funds at the time of purchase.
            </li>
            <li>
              Each time you purchase a Connection, the Fee will be debited from
              the Tokens on your MyShifts Account.
            </li>
            <li>
              An invoice will be generated at the beginning of each month
              setting out the number of Connections purchased in the preceding
              month together with the Fees paid and, if applicable, any
              outstanding balance due from you to us.
            </li>
            <li>
              Tokens and/or Token Bundles cannot be withdrawn or redeemed in
              cash or otherwise at any time, including on termination or closing
              of your MyShifts Account.
            </li>
          </ol>

          <Divider />

          <h3>7. Refund Policy</h3>
          <ol style={{ counterReset: 'lis 25' }}>
            <li>
              We will only consider a refund for a Connection which does not
              contain sufficient information for you to contact the Worker, for
              example, invalid or inadequate contact details (an
              <strong>Invalid Connection</strong>). For the avoidance of doubt,
              we will not refund you where you are unable to make contact with
              the Worker because they do not answer or respond to you.
            </li>
            <li>
              If you believe that a Connection you have purchased, is an Invalid
              Connection, you must notify us within 48 hours of purchase by
              emailing
              <a href="mailto:hello@my-shifts.co.uk">hello@my-shifts.co.uk</a>
              (with the subject marked ‘Account Query’) with sufficient detail
              for us to identify the reasons why you believe the Connection is
              an Invalid Connection.
            </li>
            <li>
              Without exception, we will only investigate potential Invalid
              Connections that have been reported in accordance with clause 7.2.
            </li>
            <li>
              We will aim to conclude our investigation within ten working days
              of receipt of your complaint provided that it has been raised in
              accordance with clause 7.2.
            </li>
            <li>
              If we determine that a Connection was an Invalid Connection, we
              will refund your MyShifts Account in Tokens to the equivalent cost
              of the Invalid Connection.
            </li>
          </ol>

          <Divider />

          <h3>8. Data Protection</h3>
          <ol style={{ counterReset: 'lis 30' }}>
            <li>Definitions.</li>
          </ol>
          <p>
            <strong>Agreed Purposes</strong>: The performance by you and us of
            our obligations under this Contract, and the connection of Employers
            to Workers that forms the subject of this Contract.
          </p>
          <p>
            <strong>
              Controller, data controller, processor, data processor, data
              subject, personal data, processing and appropriate technical and
              organisational measures, binding corporate rules
            </strong>
            : as set out in the Data Protection Legislation in force at the
            time.
          </p>
          <p>
            <strong>Data Protection Legislation</strong>: all applicable data
            protection and privacy legislation in force from time to time in the
            UK including the retained EU law version of the General Data
            Protection Regulation ((EU) 2016/679) (UK GDPR); the Data Protection
            Act 2018 (DPA 2018) (and regulations made thereunder) and the
            Privacy and Electronic Communications Regulations 2003 (SI
            2003/2426) as amended.
          </p>
          <p>
            <strong>Permitted Recipients</strong>: You and us, your and our
            employees and any third parties engaged to perform obligations in
            connection with this Contract.
          </p>
          <p>
            <strong>Shared Personal Data</strong>: the personal data to be
            shared between the parties pursuant to these Terms. Shared Personal
            Data shall be confined to the following categories of information
            relevant to the following categories of data subject:
          </p>
          <ul>
            <li>[their names]</li>
            <li>[their geographical and email addresses]</li>
            <li>[their home and mobile telephone numbers]</li>
            <li>[their health and social care qualifications]</li>
          </ul>
          <ol style={{ counterReset: 'lis 1' }}>
            <li>
              <strong>Shared Personal Data.</strong> The provisions which follow
              set out the framework for the sharing of personal data between the
              parties as data controllers. Each party acknowledges that one
              party (the Data Discloser) will regularly disclose to the other
              party (the Data Recipient) Shared Personal Data collected by the
              Data Discloser for the Agreed Purposes. Each party shall:
              <ol>
                <li>
                  ensure that it has all necessary consents and notices in place
                  to enable lawful transfer of the Shared Personal Data to the
                  Data Recipient for the Agreed Purposes;
                </li>
                <li>
                  give full information to any data subject whose personal data
                  may be processed under this agreement of the nature such
                  processing. This includes giving notice that, on the
                  termination of this agreement, personal data relating to them
                  may be retained by or, as the case may be, transferred to one
                  or more of the Data Recipients, their successors and assigns;
                </li>
                <li>
                  process the Shared Personal Data only for the Agreed Purposes;
                </li>
                <li>
                  not disclose or allow access to the Shared Personal Data to
                  anyone other than the Permitted Recipients;
                </li>
                <li>
                  ensure that all Permitted Recipients are subject to written
                  contractual obligations concerning the Shared Personal Data
                  (including obligations of confidentiality) which are no less
                  demanding than those imposed by these Terms;
                </li>
                <li>
                  ensure that it has in place appropriate technical and
                  organisational measures, reviewed and approved by the other
                  party, to protect against unauthorised or unlawful processing
                  of personal data and against accidental loss or destruction
                  of, or damage to, personal data;
                </li>
                <li>
                  not transfer any personal data received from the Data
                  Discloser outside the EEA unless the transferor:
                  <ol>
                    <li>
                      complies with the provisions of Article 26 of the UK GDPR
                      (in the event the transferee is a joint controller); and
                    </li>
                    <li>
                      ensures that (i) the transfer is to a country approved by
                      the European Commission as providing adequate protection
                      pursuant to Article 45 UK GDPR; (ii) there are appropriate
                      safeguards in place pursuant to Article 46 UK GDPR; (iii)
                      binding corporate rules are in place, or (iv) one of the
                      derogations for specific situations in Article 49 UK GDPR
                      applies to the transfer.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <strong>Compliance.</strong> Each party shall comply with the Data
              Protection Legislation and agrees that any material breach of the
              Data Protection Legislation shall give grounds to the other party
              to terminate the Contract with immediate effect (and clause 3.8
              shall apply).
            </li>
            <li>
              <strong>Mutual assistance.</strong> Each party shall assist the
              other in complying with all applicable requirements of the Data
              Protection Legislation. In particular, each party shall:
              <ol>
                <li>
                  consult with the other party about any notices given to data
                  subjects in relation to the Shared Personal Data;
                </li>
                <li>
                  promptly inform the other party about the receipt of any data
                  subject access request.
                </li>
                <li>
                  provide the other party with reasonable assistance in
                  complying with any data subject access request.
                </li>
                <li>
                  not disclose or release any Shared Personal Data in response
                  to a data subject access request without first consulting the
                  other party wherever possible;
                </li>
                <li>
                  assist the other party, at the cost of the other party, in
                  responding to any request from a data subject and in ensuring
                  compliance with its obligations under the Data Protection
                  Legislation with respect to security, personal data breach
                  notifications, data protection impact assessments and
                  consultations with supervisory authorities or regulators.
                </li>
                <li>
                  notify the other party without undue delay on becoming aware
                  of any breach of the Data Protection Legislation arising from
                  or in connection with these Terms.
                </li>
                <li>
                  at the written direction of the Data Discloser, delete or
                  return Shared Personal Data and copies thereof to the Data
                  Discloser on termination of this agreement unless required by
                  law to store the personal data.
                </li>
                <li>
                  use compatible technology for the processing of Shared
                  Personal Data to ensure that there is no lack of accuracy
                  resulting from personal data transfers.
                </li>
                <li>
                  maintain complete and accurate records and information to
                  demonstrate its compliance with this clause 8; and
                </li>
                <li>
                  provide the other party with contact details of at least one
                  employee as point of contact and responsible manager for all
                  issues arising out of the Data Protection Legislation,
                  including the joint training of relevant staff, the procedures
                  to be followed in the event of a data security breach, and the
                  regular review of the parties’ compliance with the Data
                  Protection Legislation.
                </li>
              </ol>
            </li>
            <li>
              <strong>Indemnity</strong>. Each party shall indemnify the other
              against all claims and proceedings and all liability, loss, costs
              and expenses incurred by the other as a result of any claim made
              or brought by a data subject or other legal person in respect of
              any loss, damage or distress caused to them as a result of any
              breach by the other party of the Data Protection Legislation by
              that party, its employees or agents, provided that the indemnified
              party gives to the indemnifier prompt notice of such claim, full
              information about the circumstances giving rise to it, reasonable
              assistance in dealing with the claim and sole authority to manage,
              defend and/or settle it.
            </li>
          </ol>

          <Divider />

          <h3>9. Our liability </h3>
          <ol style={{ counterReset: 'lis 5' }}>
            <li>
              We only sell Tokens and/or Token Bundles to purchase Connections
              for use by your business, and you agree not to use them for any
              resale purposes.
            </li>
            <li>
              Nothing in these Terms limits or excludes our liability for:
              <ol>
                <li>death or personal injury caused by our negligence. </li>
                <li>fraud or fraudulent misrepresentation. </li>
              </ol>
            </li>
            <li>
              Subject to clause 9.2, we will under no circumstances whatsoever
              be liable to you, whether in contract, tort (including
              negligence), breach of statutory duty, or otherwise, arising under
              or in connection with the Contract for:
              <ol>
                <li> any loss of profits, sales, business, or revenue; </li>
                <li>loss or corruption of data, information or software;</li>
                <li>loss of business opportunity; </li>
                <li>loss of anticipated savings; </li>
                <li>loss of goodwill; or </li>
                <li>any indirect or consequential loss. </li>
              </ol>
            </li>
            <li>
              Subject to clause 9.2, our total liability to you in respect of
              all losses, whether in contract, tort (including negligence),
              breach of statutory duty, or otherwise, shall in no circumstances
              exceed the amount paid by you to us in the 6 (six) month period
              preceding the date of the relevant breach.
            </li>
            <li>
              Except as expressly stated in these Terms, we do not give any
              representation, warranties or undertakings in relation to the
              Connections. Any representation, condition or warranty which might
              be implied or incorporated into these Terms by statute, common law
              or otherwise is excluded to the fullest extent permitted by law.
              In particular, we will not be responsible for ensuring that the
              Connections are suitable for your purposes.
            </li>
          </ol>

          <Divider />

          <h3>10. Events outside our control</h3>
          <ol style={{ counterReset: 'lis 10' }}>
            <li>
              We will not be liable or responsible for any failure to perform,
              or delay in performance of, any of our obligations under a
              Contract that is caused by an Event Outside Our Control. An Event
              Outside Our Control is defined below in clause 10.2.
            </li>
            <li>
              An Event Outside Our Control means any act or event beyond our
              reasonable control, including without limitation strikes, lockouts
              or other industrial action by third parties, civil commotion,
              riot, invasion, terrorist attack or threat of terrorist attack,
              war (whether declared or not) or threat or preparation for war,
              fire, explosion, storm, flood, earthquake, subsidence, epidemic,
              pandemic or other natural disaster, or failure of public or
              private telecommunications networks.
            </li>
            <li>
              If an Event Outside Our Control takes place that affects the
              performance of our obligations under a Contract:
              <ol>
                <li>
                  we will contact you as soon as reasonably possible to notify
                  you; and
                </li>
                <li>
                  our obligations under these Terms will be suspended for the
                  duration of the Event Outside Our Control.
                </li>
              </ol>
            </li>
          </ol>

          <Divider />

          <h3>11. Entire agreement</h3>
          <ol style={{ counterReset: 'lis 13' }}>
            <li>
              These Terms and our Privacy Policy and Terms of Website Use
              constitute the entire agreement between you and us and supersedes
              and extinguishes all previous agreements, promises, assurances,
              warranties, representations and understandings between us, whether
              written or oral, relating to its subject matter.
            </li>
            <li>
              You acknowledge that in entering into this Contract you do not
              rely on any statement, representation, assurance or warranty
              (whether made innocently or negligently) that is not set out in
              these Terms or our Privacy Policy or Terms of Website Use.
            </li>
            <li>
              You and we agree that neither of us shall have any claim for
              innocent or negligent misrepresentation or negligent misstatement
              based on any statement in this Contract.
            </li>
          </ol>
          
          <Divider />

          <h3>12. Other important terms</h3>
          <ol style={{ counterReset: 'lis 16' }}>
            <li>
              We may transfer our rights and obligations under a Contract to
              another organisation, but this will not affect your rights or our
              obligations under these Terms. We will always notify you by
              posting on our website if this happens.
            </li>
            <li>
              You shall not transfer your rights or your obligations under a
              Contract without our prior written consent.
            </li>
            <li>
              This Contract is between you and us. No other person shall have
              any rights to enforce any of its terms, whether under the
              Contracts (Rights of Third Parties) Act 1999 or otherwise.
            </li>
            <li>
              Each of the paragraphs of these Terms operates separately. If any
              court or relevant authority decides that any of them are unlawful
              or unenforceable, the remaining paragraphs will remain in full
              force and effect.
            </li>
            <li>
              If we fail to insist that you perform any of your obligations
              under these Terms, or if we do not enforce our rights against you,
              or if we delay in doing so, that will not mean that we have waived
              our rights against you and will not mean that you do not have to
              comply with those obligations. If we do waive a default by you, we
              will only do so in writing, and that will not mean that we will
              automatically waive any later default by you.
            </li>
            <li>
              A Contract and any dispute or claim arising out of or in
              connection with it or its subject matter or formation (including
              non-contractual disputes or claims) shall be governed by and
              construed in accordance with the law of England.
            </li>
            <li>
              The courts of England and Wales shall have exclusive jurisdiction
              to settle any dispute or claim arising out of or in connection
              with a Contract or its subject matter or formation (including
              non-contractual disputes or claims).
            </li>
          </ol>
        </div>
      </LayoutPage.Content>
    </LayoutPage>
  );
};

export default TermsEmployer;
